export default __webpack_public_path__ + "static/media/type_2_9.77ea404c.svg";